import { useState } from 'react';

interface FAQItem {
  question: string;
  answer: string;
}

const faqs: FAQItem[] = [
  {
    question: '8090影视平台是否免费？',
    answer: '8090影视平台目前提供大量免费电影资源供用户在线观看，涵盖华语电影、欧美电影、日韩电影等多个分类。我们致力于打造电影大全平台，让更多影迷能够便捷地享受高清电影带来的观影乐趣。',
  },
  {
    question: '电影的画质如何？支持哪些清晰度？',
    answer: '8090影视平台支持高清电影在线观看，大部分影片提供720P、1080P及以上的高清画质选项。我们不断优化播放技术，确保您能获得流畅、清晰的观影体验。具体清晰度取决于片源，建议在网络条件良好的环境下选择最高画质。',
  },
  {
    question: '有哪些电影分类可以选择？',
    answer: '8090影视的电影大全涵盖了丰富的分类：华语电影（中国大陆、香港、台湾）、欧美电影（好莱坞大片、欧洲艺术片）、日韩电影（日本动画、韩国剧情片）、经典电影（影史不朽佳作）、最新上映（院线新片）以及高分推荐（口碑佳作）。您可以通过顶部导航或分类页面快速筛选。',
  },
  {
    question: '如何搜索我想看的电影？',
    answer: '您可以通过网站顶部的搜索框输入电影名称、导演或演员名字进行搜索。此外，您也可以通过电影分类页面按类型、地区、年代等维度筛选影片。我们的搜索系统会帮助您快速定位电影大全中的目标影片。',
  },
  {
    question: '支持哪些设备观看？',
    answer: '8090影视全面支持PC端、平板电脑和手机端在线观看。网站采用了响应式设计，能够自适应不同屏幕尺寸，确保您在任何设备上都能获得舒适的观影体验。',
  },
  {
    question: '经典电影资源多久更新一次？',
    answer: '我们的电影大全片库会持续更新，经典电影资源会定期补充和优化。同时，最新上映的电影也会在获得版权后第一时间上线，确保您能及时观看到最新电影和经典电影资源。',
  },
  {
    question: '8090影视与其它电影平台有什么不同？',
    answer: '8090影视专注于打造纯粹的电影大全平台，聚合最新电影、经典电影、高清电影资源。我们注重用户体验，提供简洁直观的界面设计、快速的加载速度和流畅的播放体验。同时涵盖华语电影、欧美电影等全品类内容，满足不同观众的观影需求。',
  },
  {
    question: '观影过程中遇到问题怎么办？',
    answer: '如果您在观影过程中遇到任何问题，可以通过网站的联系方式联系我们。我们的客服团队会尽快协助您解决播放、加载等方面的问题。您也可以查看我们的帮助中心获取常见问题的解决方案。',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };

  return (
    <section className="py-16 md:py-20 px-4 md:px-8">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-white">
            常见问题
          </h2>
          <p className="text-cinema-text-dim text-sm mt-2">关于8090影视电影大全平台的常见疑问解答</p>
        </div>

        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
        />

        <div className="space-y-3">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="rounded-lg bg-cinema-card border border-cinema-border overflow-hidden"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer"
              >
                <h4 className="text-white text-sm font-medium pr-4">
                  {faq.question}
                </h4>
                <div className={`w-6 h-6 flex items-center justify-center flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-45' : ''}`}>
                  <i className={`text-cinema-text-dim text-sm ${openIndex === index ? 'ri-subtract-line text-cinema-gold' : 'ri-add-line'}`}></i>
                </div>
              </button>
              <div
                className={`transition-all duration-300 overflow-hidden ${
                  openIndex === index ? 'max-h-96 pb-4' : 'max-h-0'
                }`}
              >
                <p className="px-5 text-cinema-text-dim text-sm leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}